import { render, staticRenderFns } from "./TextareaAutosize.vue?vue&type=template&id=4701de78&"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js&"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4701de78')) {
      api.createRecord('4701de78', component.options)
    } else {
      api.reload('4701de78', component.options)
    }
    module.hot.accept("./TextareaAutosize.vue?vue&type=template&id=4701de78&", function () {
      api.rerender('4701de78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Controls/TextareaAutosize.vue"
export default component.exports